import {
  Eye,
  Activity,
  Bell,
  LayoutGrid,
  Factory,
} from "lucide-react";

const FEATURES = [
  {
    icon: Eye,
    title: "Booking Visibility",
    desc: "Every quote, confirmation and equipment release captured against your shipment record in real time.",
  },
  {
    icon: Activity,
    title: "Real-Time Milestones",
    desc: "From gate-in to loaded to discharged — events stream into FreightIQ™ the moment they occur.",
  },
  {
    icon: Bell,
    title: "Shipment Updates",
    desc: "Smart notifications surface roll-overs, ETA shifts and document changes before they become problems.",
  },
  {
    icon: LayoutGrid,
    title: "Workspace Integration",
    desc: "Purchase Order, Inspection™, FreightIQ™ and Tracking — one connected operating system.",
  },
  {
    icon: Factory,
    title: "Factory-to-Port Coordination",
    desc: "Plan container pick-ups, factory loading and gate-in windows on a single coordinated timeline.",
  },
];

export default function FeatureCards() {
  return (
    <section
      id="features"
      data-testid="features-section"
      className="py-24 md:py-32 bg-slate-50/60 border-y border-slate-100"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <div className="text-xs tracking-[0.18em] uppercase font-bold text-[#3B82F6]">
            Why DeMaxtore
          </div>
          <h2 className="mt-3 font-display font-extrabold text-4xl md:text-5xl tracking-[-0.02em] text-[#0B1F3A]">
            Why importers choose
            <br />
            <span className="text-[#0B1F3A]/55">DeMaxtore.</span>
          </h2>
          <p className="mt-5 text-lg text-slate-600 max-w-2xl">
            Built for global importers moving freight out of Turkey — not for
            traditional forwarders.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-6">
          {FEATURES.map((f, i) => {
            const Icon = f.icon;
            return (
              <div
                key={f.title}
                data-testid={`feature-card-${i}`}
                className="group relative rounded-2xl bg-white border border-slate-200 p-7 hover:border-[#3B82F6]/40 hover:-translate-y-0.5 hover:shadow-[0_24px_60px_-30px_rgba(59,130,246,0.4)] transition-all duration-300"
              >
                <div className="flex items-center justify-center h-12 w-12 rounded-xl bg-[#3B82F6]/8 text-[#3B82F6] group-hover:bg-[#3B82F6] group-hover:text-white transition-colors">
                  <Icon className="h-5 w-5" strokeWidth={1.75} />
                </div>
                <h3 className="mt-6 font-display font-bold text-xl text-[#0B1F3A] tracking-tight">
                  {f.title}
                </h3>
                <p className="mt-2 text-[15px] leading-relaxed text-slate-600">
                  {f.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
